import React, { useEffect, useState } from "react";
import {
  LanguageSwitcherSelectors,
  UserContextSelectors
} from "../../redux/selectors";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { BrandUtils } from "../../utils/brandUtils";
import { NavigationUtils, TrackingUtils, UrlUtils } from "../../utils";
import { SVGIcon2 } from "../common/SVGIconV2";

const LanguagesMenuMobile = () => {
  const data = useSelector(LanguageSwitcherSelectors.data);
  const isNative = useSelector(UserContextSelectors.isNative);
  const showCountrySelection = !BrandUtils.isPokerClient();
  const [languagesData, setLanguagesData] = useState([]);
  const [currentLang, setCurrentLang] = useState(null);

  useEffect(() => {
    let currentLang = "English";
    let _data = data ? { ...data } : {};
    if (data?.languageSettings?.current) {
      setCurrentLang(_data.languageSettings.current);
      const hasLanguage = _data.languages.some(x => x.title === currentLang);
      if (!hasLanguage) {
        _data.languages.push(createLanguage(currentLang, ""));
      }
    }
    setLanguagesData(_data);
  }, [data, isNative]);

  const handleLanguageOrCountryClick = (item, isLanguage) => {
    const { title } = item;
    TrackingUtils.sendAnalytics({
      dataCategory: "User Area",
      dataAction: "click",
      dataLabel: isLanguage ? "Selected language" : "Selected country",
      dataCustom: { language: title }
    });
  };

  const createLanguage = (title, url) => {
    return {
      title: title,
      url: url
    };
  };

  const getNavigationUrl = url => {
    return UrlUtils.getURLWithOrigin(url, window.location.origin);
  };

  return (
    <div className={"language-menu inner-mobile-menu"}>
      <div className="languageOptions">
        <p>
          {languagesData?.languageSettings?.title
            ? languagesData.languageSettings.title
            : "Choose your Language:"}
        </p>
        <ul className="languageSelect">
          {languagesData?.languages?.map((item, index) => {
            const url = !BrandUtils.isPokerClient()
              ? getNavigationUrl(item.url)
              : item.url;
            return (
              <li key={index}>
                <a
                  href={url}
                  className={classNames({
                    checkedOption: item.title === currentLang
                  })}
                  data-navigation-ignore={true}
                  onClick={() => handleLanguageOrCountryClick(item, true)}
                >
                  <i>
                    <SVGIcon2 iconName="check" />
                  </i>
                  <span className="ellipsis-span">{item.title}</span>
                </a>
              </li>
            );
          })}
        </ul>
        <div className="clear" />
        {showCountrySelection && (
          <>
            <p>
              {languagesData?.countrySettings?.title
                ? languagesData.countrySettings.title
                : "Choose your Country:"}
            </p>
            <ul className="countrySelect">
              {languagesData?.countries?.map((item, index) => (
                <li key={index}>
                  <a
                    href={
                      isNative
                        ? NavigationUtils.addQueryToLink(item.url, {
                            NativeExternal: "true"
                          })
                        : item.url
                    }
                    target={isNative ? "_blank" : "_self"}
                    data-navigation-ignore={true}
                    onClick={() => handleLanguageOrCountryClick(item, false)}
                  >
                    <i>
                      <svg>
                        <use />
                      </svg>
                    </i>
                    <span className="ellipsis-span">{item.title}</span>
                  </a>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default LanguagesMenuMobile;
